<template>
  <div>
    Ez az oldal az Ön számára elérhető, mert Ügyfélkapun keresztül jelentkezett be.
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
